var _path, _g, _path2, _g2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoe4YouLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "page-logo__icon--desktop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#322173",
    d: "M-.001-.001h104v104h-104z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#cc1112",
    d: "M9.075 76.89a13.411 13.411 0 1 1 13.411 13.411A13.411 13.411 0 0 1 9.075 76.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.432 74.906a6.6 6.6 0 0 0 .93-1.393l.132.088a4.224 4.224 0 0 0-.264 1.372v2.5l-2.943.156v-.091zm-7.678 7.1l8.476-.177-.222 3.34h5.753l-.152-3.34 2.256.177v-4.692l-2.1.155v-8.984h-7.169l-6.837 9.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.699 68.25l5.82 9.493v7.194h5.93v-7.194l5.71-9.493h-6.816l-1.195 2.789c-.222.509-.377 1.04-.553 1.569h-.177l-1.859-4.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.794 67.984c-5.067 0-9.228 3.409-9.228 8.652 0 5.354 4.138 8.563 9.228 8.563s9.228-3.209 9.228-8.563c0-5.244-4.16-8.652-9.228-8.652m0 5.487a3.079 3.079 0 0 1 3.121 3.253 3.121 3.121 0 1 1-6.24 0 3.079 3.079 0 0 1 3.119-3.253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M87.494 68.25v9.293c0 1.306-.044 2.457-1.659 2.457s-1.661-1.151-1.661-2.457V68.25h-6.063v9.869c0 4.868 3.053 7.081 7.723 7.081s7.724-2.212 7.724-7.081V68.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.374 54.475a15.021 15.021 0 0 0 6.418 1.528c3.607 0 7.237-1.971 7.237-5.953 0-2.833-1.859-4.2-4.426-4.78l-1.373-.31c-.465-.11-1.218-.2-1.218-.818 0-.687.775-.887 1.307-.887a6.309 6.309 0 0 1 3.519 1.261l1.637-4.27a9.927 9.927 0 0 0-5.289-1.461c-3.629 0-7.236 2.212-7.236 6.174 0 2.612 1.99 4.005 4.36 4.426l1.217.221c.552.111 1.349.178 1.349.93s-.951 1-1.549 1a6.366 6.366 0 0 1-3.784-1.528l-.309-.243z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.187 55.736h5.842v-5.8h3.719v5.8h5.842V39.05h-5.842v5.622h-3.719V39.05h-5.842z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.788 38.784c-5.069 0-9.228 3.409-9.228 8.653 0 5.355 4.138 8.565 9.228 8.565s9.226-3.21 9.226-8.565c0-5.244-4.159-8.653-9.226-8.653m0 5.489a3.08 3.08 0 0 1 3.119 3.253 3.122 3.122 0 1 1-6.242 0 3.081 3.081 0 0 1 3.123-3.253"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.106 55.736h11.4v-4.558h-5.29V49.54h4.671v-4.337h-4.671v-1.594h5.113V39.05h-11.22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoe4YouLogo);
export default __webpack_public_path__ + "static/media/shoe4you_logo.9311ffdb945bda0f097bb0479f0e1977.svg";
export { ForwardRef as ReactComponent };